<template>
  <section v-loading="dianjinSubmiting" class>
    <div
      v-loading="loading"
      class="adj-publish adj-publish-loading"
      :class="{ hide: !loading }"
    ></div>
    <div class="adj-publish" :class="{ hide: loading }">
      <ul class="tabs" :class="{ 'is-diabled': isEdit }">
        <li
          class="tab"
          v-for="(item, index) in tabs"
          :key="item.type"
          :class="{ 'tab--active': activeTab === index, 'is-disabled': isEdit }"
          @click="changeTab(index)"
        >
          {{ item.name }}
        </li>
      </ul>
      <el-form
        :model="model"
        :rules="rules"
        ref="model"
        label-position="left"
        class="form"
      >
        <el-form-item class="adj-publish-inp" label="标题:" prop="title">
          <el-input
            v-model="model.title"
            placeholder="请输入标题"
            class="text-input"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          class="adj-publish-item"
          :class="{ hide: activeTab !== 0 }"
          label="正文:"
          prop="content"
        >
          <Ckeditor4 v-model="model.content"></Ckeditor4>
        </el-form-item>
        <el-form-item
          label="上传视频文件:"
          prop="videoFileName"
          v-if="activeTab == 1"
        >
          <div class="adj-item-upload">
            <el-input
              v-model="model.videoFileName"
              disabled
              class="text-input adj-item-upload-inp"
              prop="videoFileName"
            ></el-input>
            <aliyun-upload
              class="ailiyunupLoad"
              @uploadComplete="onVideoUploadComplete"
              @uploadFailed="onVideoUploadFailed"
              @startUpload="onVideoUploadStart($event)"
              @uploadProgress="onVideoUploadProgress($event)"
              @uploadCanceled="onVideoUploadCanceled($event)"
              @onError="onError"
              :temp="`MP4`"
              :fileType="`video`"
              :showCacelBtn="true"
              :disabled="model.videoUploading"
            >
              <el-button
                style="margin-left: 15px"
                type="primary"
                :loading="model.videoUploading"
                :disabled="model.videoUploading"
                >{{ model.videoUploading ? '正在上传' : '选择文件' }}</el-button
              >
              <el-progress
                :width="35"
                class="progress-style"
                v-if="videoPercentage !== 0"
                type="circle"
                :percentage="videoPercentage"
                status="success"
                :stroke-width="2"
              ></el-progress>
            </aliyun-upload>
          </div>
        </el-form-item>
        <el-form-item
          label="上传音频文件:"
          prop="audioFileName"
          v-if="activeTab == 2"
        >
          <div class="adj-item-upload">
            <div>
              <el-input
                v-model="model.audioFileName"
                disabled
                class="text-input adj-item-upload-inp"
                prop="audioFileName"
              ></el-input>
              <aliyun-upload
                class="ailiyunupLoad"
                :disabled="model.audioUploading"
                @uploadComplete="onAudioUploadComplete"
                @onAudioUploadFailed="onAudioUploadFailed"
                @startUpload="onAudioUploadStart($event)"
                @uploadProgress="onAudioUploadProgress($event)"
                @uploadCanceled="onAudioUploadCanceled($event)"
                @onError="onError"
                :temp="`MP3`"
                :fileType="`audio`"
                :showCacelBtn="true"
              >
                <el-button
                  style="margin-left: 15px"
                  type="primary"
                  :loading="model.audioUploading"
                  :disabled="model.audioUploading"
                  >{{
                    model.audioUploading ? '正在上传' : '选择文件'
                  }}</el-button
                >
                <el-progress
                  :width="35"
                  class="progress-style"
                  v-if="audioPercentage !== 0"
                  type="circle"
                  :percentage="audioPercentage"
                  status="success"
                  :stroke-width="2"
                ></el-progress>
              </aliyun-upload>
            </div>
          </div>
          <!-- <span class="adj-item-upload-note">目前仅支持MP3格式的音频文件</span> -->
        </el-form-item>
        <el-form-item
          label="封面:"
          prop="coverImageUrl"
          v-if="activeTab == 0 || activeTab == 1"
        >
          <el-upload
            class="avatar-uploader"
            :class="{ 'avatar-uploader-has': model.coverImageUrl }"
            :action="uploadUrl"
            :show-file-list="false"
            :before-upload="beforeImageUpload"
            :on-success="handleImageSuccess"
            :on-progress="uploadVideoProcess"
            :accept="'image/*'"
          >
            <img
              v-if="model.coverImageUrl"
              :src="model.coverImageUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <el-progress
              v-if="coverImgProgressFlag"
              :percentage="coverImgProgress"
            ></el-progress>
          </el-upload>
        </el-form-item>
        <el-form-item label="涉及股票:" class="adj-publish-inp">
          <el-select
            v-model="stockIndex"
            :value-key="`code`"
            :multiple="false"
            :remote="true"
            :allow-create="false"
            :filterable="true"
            :remote-method="remoteMethod"
            :loading="stockLoading"
            :placeholder="`添加股票`"
            @change="onChange"
            @remove-tag="onRemoveTag"
          >
            <el-option
              v-for="item in stockOptions"
              :key="item.code"
              :label="item.name"
              :value="item"
            >
              <div style="display: flex; justify-content: space-between">
                <span style="float: left; min-width: 120px">{{
                  item.name
                }}</span>
                <span class="sle-sp">{{ item.code }}</span>
                <div class="add-icon">
                  <i class="el-icon-circle-plus-outline"></i>
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" " class="adj-publish-inp">
          <ul class="adj-publish-stock">
            <li>
              <div class="adj-p-stock-head adj-p-stock-head-name">
                <span>证券名称</span>
              </div>
              <span class="adj-p-stock-head">价格</span>
              <span class="adj-p-stock-head">涨跌幅</span>
              <span class="adj-p-stock-head adj-p-stock-head-last">操作</span>
            </li>
            <li v-for="item in model.stocks" v-bind:key="item.code">
              <div class="adj-stock-name">
                <label>{{ item.name }}</label>
                <span>{{ item.code }}</span>
              </div>
              <span
                class="adj-stock-price"
                :class="{
                  'adj-stock-up': item.fluctuation > 0,
                  'adj-stock-down': item.fluctuation < 0
                }"
                >{{ item.price }}</span
              >
              <span
                class="adj-stock-price"
                :class="{
                  'adj-stock-up': item.fluctuation > 0,
                  'adj-stock-down': item.fluctuation < 0
                }"
                >{{ item.fluctuation }}</span
              >
              <span @click="stockRemove(item.code)" class="adj-stock-option"
                >删除</span
              >
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="是否收费:" prop="isPaid">
          <el-radio-group v-model="model.isPaid">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click.native="dianjinSubmit()" type="primary"
            >发布</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import Urls from '@/assets/js/Urls'
import AliyunUpload from '@/components/AliyunUpload/AliyunUpload'
import { search, getStockPrice } from '@/api/stock'
import { authorPublish, authorGetDetail } from '@/api/dianjin'
import Ckeditor4 from '@/components/Ckeditor4/Ckeditor4'
import { getResourceDetail } from '@/api/resource'
import addPng from './images/add.png'

export default {
  name: 'Publish',
  components: { AliyunUpload, Ckeditor4 },
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dianjinSubmiting: false,
      loading: false,
      detailId: this.id,
      dianjinDetail: '',
      stockIndex: '',
      addIcon: addPng,
      tabs: [
        { name: '图文', type: 4 },
        { name: '视频', type: 1 },
        { name: '音频', type: 2 }
      ],
      activeTab: 0,
      videoPercentage: 0,
      audioPercentage: 0,
      uploadUrl: `${Urls.DOMAIN_STATIC}/Upload/Image`,
      imageUrl: null,
      model: {
        id: 0,
        type: 4,
        title: '',
        content: '',
        stocks: [],
        isPaid: 'false',
        coverImageUrl: '',
        videoFileName: '',
        videoId: '',
        videoUploading: false,
        audioFileName: '',
        audioId: '',
        audioUploading: false
      },
      rules: {
        title: { required: true, message: '请输入点金标题', trigger: 'blur' },
        content: {
          required: true,
          message: '请输入点金正文',
          trigger: 'change'
        },
        coverImageUrl: {
          required: true,
          message: '请上传封面图片',
          trigger: 'change'
        },
        videoFileName: {
          required: true,
          message: '请上传视频文件',
          trigger: 'change'
        },
        audioFileName: {
          required: true,
          message: '请上传音频文件',
          trigger: 'change'
        }
      },
      stockOptions: [],
      stockLoading: false,
      rootPath: `${Urls.DOMAIN_STATIC}/Upload/Image`,
      coverImgProgress: 0, // 动态显示进度条
      coverImgProgressFlag: false // 关闭进度条
    }
  },
  computed: {
    isEdit() {
      return this.detailId > 0
    }
  },
  methods: {
    uploadVideoProcess(event, file, fileList) {
      this.coverImgProgressFlag = true // 显示进度条
      this.coverImgProgress = parseInt(event.percent) // 动态获取文件上传进度
      if (this.coverImgProgress >= 100) {
        this.coverImgProgress = 100
        setTimeout(() => {
          this.coverImgProgressFlag = false
        }, 1000) // 一秒后关闭进度条
      }
    },
    changeTab(index) {
      if (this.isEdit) {
        return
      }
      this.activeTab = index
      this.model.type = this.tabs[index].type
    },
    beforeImageUpload(file) {
      if (file.type.split('/')[0] !== 'image') {
        this.$alert('请上传【图片】类型的文件', '提示', {
          type: 'warning'
        }).then(() => {})
        return false
      }
    },
    handleImageSuccess(res, file) {
      this.model.coverImageUrl = this.imageUrl =
        res.result.code === 0 ? res.detail : null
      this.$refs.model.validateField('coverImageUrl')
    },

    // 上传视频文件开始
    onVideoUploadStart(videoInfo) {
      console.log('开始')
      this.model.videoUploading = true
    },
    onVideoUploadProgress(progress) {
      this.videoPercentage = Math.round(progress * 100)
    },
    onVideoUploadCanceled(videoInfo) {
      console.log('取消')
      this.model.videoUploading = false
    },
    onVideoUploadComplete(videoInfo, detail) {
      console.log('完成,videoInfo:', videoInfo)
      console.log('完成,detail:', detail)
      this.model.videoUploading = false
      this.videoPercentage = 100
      // 关联id
      this.model.videoId = detail.id
      this.model.videoFileName = videoInfo.fileName
    },
    onVideoUploadFailed() {
      this.model.videoUploading = false
    },
    // 上传视频文件结束

    // 上传音频文件开始
    onAudioUploadStart(videoInfo) {
      console.log('开始')
      this.model.audioUploading = true
    },
    onAudioUploadProgress(progress) {
      this.audioPercentage = Math.round(progress * 100)
    },
    onAudioUploadCanceled(videoInfo) {
      console.log('取消')
      this.model.audioUploading = false
    },
    onAudioUploadComplete(videoInfo, detail) {
      console.log('完成,videoInfo:', videoInfo)
      console.log('完成,detail:', detail)
      this.model.audioUploading = false
      this.audioPercentage = 100
      // 关联id
      this.model.audioId = detail.id
      this.model.audioFileName = videoInfo.fileName
    },
    onError(msg) {
      console.log('msg', msg)
      this.$alert(msg, '提示', {
        type: 'warning'
      }).then(() => {})
    },
    onAudioUploadFailed() {
      this.model.audioUploading = false
    },
    // 上传音频文件结束

    // 关联股票远程搜索
    async remoteMethod(query) {
      if (query !== '') {
        this.stockLoading = true
        setTimeout(async () => {
          this.stockLoading = false
          const { detail } = await search({ keyword: query, limit: 999 })
          this.stockOptions = detail
        }, 200)
      } else {
        this.stockOptions = []
      }
    },
    async onChange(data) {
      if (
        !this.model.stocks ||
        !this.model.stocks.some(x => x.code === data.code)
      ) {
        // price
        const result = await getStockPrice([data.id])
        if (
          result &&
          result.detail &&
          result.detail.valueList &&
          result.detail.valueList.length > 0 &&
          result.detail.valueList[0].fieldValue[2]
        ) {
          var price = (
            parseFloat(result.detail.valueList[0].fieldValue[2]) / 10000
          ).toFixed(2)
          var fluctuation = (
            parseFloat(result.detail.valueList[0].fieldValue[4]) / 100
          ).toFixed(2)
          data.price = price
          data.fluctuation = fluctuation
        }
        this.model.stocks.push(data)
        this.stockIndex = null
      }
    },
    onRemoveTag(val) {},
    stockRemove(code) {
      this.model.stocks = this.model.stocks.filter(x => x.code !== code)
    },
    // 提交
    async dianjinSubmit() {
      var validatePass = this.validateForm()
      if (!validatePass) {
        return
      }
      this.$confirm('确定发布点金吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          // 提交内容
          console.log('validatePass:', validatePass)
          if (validatePass) {
            // 加载遮罩
            this.dianjinSubmiting = true
            // 构建data
            var data = {
              type: this.model.type,
              title: this.model.title,
              coverImgUrl: this.model.coverImageUrl,
              isFree: this.model.isPaid !== 'true',
              content: this.model.content
            }
            data.relateStocks = this.model.stocks.map(item => {
              return {
                id: item.id,
                stockId: item.id,
                stockCode: item.code,
                name: item.name
              }
            })
            if (data.type === 1) {
              data.resourceId = this.model.videoId
              data.content = ''
            } else if (data.type === 2) {
              data.resourceId = this.model.audioId
              data.content = ''
            }
            console.log('dianjinSubmit.data:', data)
            const { result } = await authorPublish(data)
            if (result.code === 0) {
              // 发布成功
              console.log('dianjinSubmit.success,result:', result)
              this.$router.push('/excl-author/dianjin?tab=2')
              window.location.reload()
            } else {
              // console.log('result', result)
              this.$alert(result.msg, '提示', {
                confirmButtonText: '确定',
                type: 'error'
              })
              this.dianjinSubmiting = false
            }
          }
        })
        .catch(() => {})
    },
    validateForm() {
      var validateResult = true
      var validateField = ['title']
      console.log('activeTab', this.activeTab)
      if (this.activeTab === 0) {
        // 图文
        validateField.push('content')
        validateField.push('coverImageUrl')
      } else if (this.activeTab === 1) {
        // 视频
        validateField.push('videoFileName')
        validateField.push('coverImageUrl')
      } else {
        // 音频
        validateField.push('audioFileName')
      }
      this.$refs.model.validateField(validateField, errorMsg => {
        if (errorMsg) {
          validateResult = false
        }
      })

      return validateResult
    },
    // 初始化
    async initEdit() {
      const { result, detail } = await authorGetDetail(this.detailId)
      if (result.code === 0) {
        this.model = detail.dianJinInfo
        var stockList = detail.stocks.map(item => {
          return {
            category: item.category,
            code: item.stockCode,
            exchange: 1,
            id: Number(item.stockCode),
            name: !item.name ? item.stockCode : item.name,
            station: 1
          }
        })
        this.$set(this.model, 'stocks', stockList)
        // this.$set(this.model, 'coverImageUrl', detail.dianJinInfo.coverImageUrl)
        this.$set(
          this.model,
          'isPaid',
          detail.dianJinInfo.isFree ? 'false' : 'true'
        )

        // 获取资源详情
        var resouceDetail = await this.getResourceDetail(
          detail.dianJinInfo.resourceIdentity
        )
        this.model.videoId = this.model.videoId =
          detail.dianJinInfo.resourceIdentity

        this.model.videoFileName = this.model.audioFileName = !resouceDetail
          ? ''
          : resouceDetail.title

        this.stockOptions = this.model.stocks
        for (let index = 0; index < this.tabs.length; index++) {
          if (this.tabs[index].type === detail.dianJinInfo.type) {
            this.activeTab = index
            break
          }
        }
        this.loading = false
      }
    },
    async getResourceDetail(id) {
      const detail = await getResourceDetail(id)
      if (!detail) {
        return {
          title: ''
        }
      }
      return detail
    }
  },

  async created() {
    if (this.isEdit) {
      this.loading = true
      await this.initEdit()
    }
  },
  async mounted() {},
  watch: {
    // 监听富文本，实现必选效果
    'model.content': {
      handler(val, oldVal) {
        if (!this.loading && val !== oldVal) {
          this.$refs.model.validateField('content')
        }
      },
      deep: true
    }
  }
}
</script>

<style>
.adj-publish .adj-publish-item {
  width: 720px;
}
.adj-publish .adj-publish-inp {
  width: 466px;
}
.adj-publish .el-select {
  width: 100%;
}
.adj-publish .el-select__tags {
  max-width: 600px !important;
}
.adj-publish .el-input .el-input__count {
  width: auto;
}
.adj-publish .el-form-item {
  margin-bottom: 30px;
}
.adj-publish .el-form-item__label {
  min-width: 110px !important;
}
.adj-publish .el-form-item__content {
  margin-left: 110px !important;
}
.adj-publish .adj-item-upload {
  /* display: flex;
  align-items: center; */
}
.adj-publish .adj-item-upload .el-button {
  margin-left: 15px;
  background-color: #ffff;
  color: #046bcc;
  width: 130px;
}
.adj-publish .adj-item-upload .el-button.is-disabled {
  color: #a0cfff;
}
.adj-container .el-form .is-error .cke_chrome {
  border-color: #f56c6c !important;
}
.hide {
  display: none !important;
}
.show {
  display: block !important;
}
</style>

<style lang="scss" scoped>
.adj-publish-loading {
  height: 550px;
}
.adj-publish {
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: #ffffff;
  .tabs {
    line-height: 60px;
    font-size: 16px;
    color: #262626;
    // text-align: center;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    margin: 0 50px;

    .tab {
      width: 98px;
      cursor: pointer;
    }

    .tab--active {
      position: relative;
      color: #046bcc;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        // transform: translateX(-50%);
        width: 34px;
        height: 4px;
        background-color: #046bcc;
      }
    }
    .tab--active.is-disabled {
      color: #909399;
      &::after {
        background-color: #909399;
      }
    }
  }
  .tabs.is-diabled {
    color: #909399;
    .tab {
      cursor: default;
    }
  }
  .form {
    margin: 50px;
    margin-right: 0;
    .text-input {
      height: 44px;
      border-radius: 5px;
      // display: flex;
      // align-items: center;
    }
    .adj-item-upload-inp {
      width: 210px;
    }
    .adj-item-upload-note {
      font-size: 13px;
      line-height: 14px;
      margin-left: 10px;
      color: #858585;
    }
  }
}
.avatar {
  max-width: 600px;
}
.avatar-uploader {
  width: 180px;
  display: inline-block;
  border: dashed 1px #ebebeb;
}
.avatar-uploader-has {
  border: none;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  display: inline-block;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.progress-style {
  margin-left: 10px;
  vertical-align: bottom;
}
.upload-video {
  margin-left: 10px;
  display: inline-block;
}
.sle-sp {
  color: #8492a6;
  font-size: 13px;
}
.add-icon {
  width: 15px;
  height: 100%;
  color: #409eff;
}
.selected .sle-sp {
  color: #409eff;
}
.adj-publish {
  .adj-publish-stock {
    width: 442px;
    background-color: #ffffff;
    border-radius: 5px;
    border: solid 1px #ebebeb;
    text-align: center;
    > li {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .adj-p-stock-head {
      width: 122px;
      line-height: 34px;
      background-color: #fafafa;
      border-radius: 5px 0px 0px 0px;
      border-right: 1px solid #ebebeb;
    }
    .adj-p-stock-head-last {
      border-right: none;
    }
    .adj-p-stock-head-name {
      width: 250px;
    }
    .adj-stock-name {
      width: 250px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #ebebeb;
      > label {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #262626;
      }
      > span {
        margin-left: 5px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #858585;
      }
    }
    .adj-stock-price {
      width: 122px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #262626;
      border-right: 1px solid #ebebeb;
    }
    .adj-stock-option {
      width: 122px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #046bcc;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .adj-stock-up {
      color: #e64c2e;
    }
    .adj-stock-down {
      color: #38bf26;
    }
  }
}
</style>
